<template>
  <div>
    <span class="common-list-header-export" @click.stop="dialogVisible = true">
      <i class="iconfont iconicon_Import"></i>{{title}}
    </span>
    <el-dialog
      class="import-modal"
      :title="title"
      :visible.sync="dialogVisible"
      width="450px"
      @close="handleCancel">
      <template v-if="status === -1">
        <div class="import-modal__content" >
          <div>
            <slot name="header"></slot>
          </div>
          <el-row class="mb-16" type="flex" align="middle" v-if="templateLink">
            <span>点击下载</span>
            <el-link 
              :href="templateLink" 
              target="_blank"
              type="primary">批量导入模板</el-link>
          </el-row>
          <div v-loading="uploading">
            <el-upload
              drag
              action="/"
              :http-request="customUpload"
              :show-file-list="false"
              v-bind="uploadOption">
              <template v-if="!file">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </template>
              <el-row v-else class="file-box" type="flex" align="middle" :gutter="16">
                <el-col :span="18">
                  <el-row type="flex" align="middle">
                    <i class="el-icon-document-checked"></i>
                    <span style="width: 180px;text-align: left">{{file && file.name}}</span>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-button type="primary" size="small">替换文件</el-button>
                </el-col>
              </el-row>
            </el-upload>
          </div>
          <div>
            <slot name="footer"></slot>
          </div>
        </div>
        <div class="import-modal-operation">
          <el-button @click="handleCancel">关闭</el-button>
          <el-button type="primary" @click="handleImport" :loading="loading">上传并导入</el-button>
        </div>
      </template>
      <template v-else-if="status === 1">
        <div class="import-modal__content" >
          <div class="import-modal__content--importing">
            <p class="desc">关闭本弹窗不影响导入</p>
            <p><i class="el-icon-loading"></i></p>
            导入中...
          </div>
          
        </div>
        <div class="import-modal-operation">
          <el-button @click="handleCancel">关闭</el-button>
        </div>
      </template>
      <template v-else-if="status === 2">
        <div class="import-modal__content" >
          <div class="import-modal__content--imported">
            <p><i class="el-icon-success"></i></p>
            <p class="desc">导入完成 <span>({{successCount}}/{{totalCount}})</span></p>
          </div>
          
        </div>
        <div class="import-modal-operation">
          <el-button @click="handleCancel">关闭</el-button>
        </div>
      </template>
    </el-dialog> 
  </div>
</template>
<script>
import {uploadFileDirect, addImportTask, checkImportStatus} from '@/server/common'
const FILE_SIZE_RATE = 1024
export default {
  name: 'ZImportFile',
  props: {
    title: {
      type: String,
      required: true
    },
    templateLink: String,
    accept: {
      type: String,
      default: '.xlsx,.xls,.csv'
    },
    fileValidator: Function,
    // fileSize 以MB为单位
    fileSize: {
      type: Number,
      default: 10
    },
    getUploadExtraParams: {
      type: Function,
      required: true
    }
  },
  components: {
   
  },
  data() {
    return {
      uploading: false,
      timer: null,
      dialogVisible: false,
      fileSrc: '',
      file: null,
      status: -1, // 导入状态 -1：未导入  1 导入中  2 导入完成
      successCount: 0,
      totalCount: 0,
      loading: false
    }
  },
  computed: {
    uploadOption() {
      const data = {}
      if (this.accept) {
        data.accept = this.accept
      }
      return data
    }
  },
  async mounted() {
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.timer);
    })
  },
  methods: {
    async handleImport() {
      if (!this.file) {
        return this.$message.error('请上传文件')
      }
      this.loading = true
      const {data: uploadData} = await uploadFileDirect(this.file, 'common')
      if (uploadData.code === this.$code) {
        const params = this.getUploadExtraParams() || {}
        const postData = {
          ...params,
         fileUrl: uploadData.data.absolutePath,
         sourceFileName: this.file.name
        }
        const {data} = await addImportTask(postData)
        if (data.code === this.$code) {
          this.status = 1
          this.checkImportStatus(data.data)
        }
      } else {
        let errorMsg = '上传文件失败，请稍后重试或联系管理员。'
        if (uploadData.msg) {
          errorMsg += JSON.stringify(uploadData.msg)
        }
        this.$message.error(errorMsg)
        // this.$message.error(data.msg)
      }
      this.loading = false
    },
    handleCancel() {
      this.dialogVisible = false
      this.status = -1
      this.file = null
      clearTimeout(this.timer)
    },
    async beforeUpload(option) {
      const {file} = option
      if (typeof this.fileValidator === 'function') {
        return this.fileValidator(option)
      }
      if (this.accept) {
        const typeList = this.accept.split(',')
        const valid = typeList.some(i => file.name.endsWith(i))
        if (!valid) {
          this.$message.error(`只支持${typeList}的文件`)
          return false
        }
      }
      if (this.fileSize && this.fileSize * FILE_SIZE_RATE * FILE_SIZE_RATE < file.size ) {
        this.$message.error(`只支持${this.fileSize}M大小的文件`)
        return false
      }
      return true
    },
    async customUpload(option) {
      this.uploading = true
      const valid = await this.beforeUpload(option)
      if (valid) {
        this.file = option.file
      }
      this.uploading = false
    },
    async checkImportStatus(taskId) {
      const { data } = await checkImportStatus(taskId)
      if (data.code === this.$code) {
        if ([1, 2].includes(+data.data.status)) {
          this.timer = setTimeout(() => {
            this.checkImportStatus(taskId)
          }, 3000)
        } else if (+data.data.status === 3) {
          this.status = 2
          this.totalCount = data.data.totalCount
          this.successCount = data.data.successCount
          this.$emit('import-success', this.successCount)
        }
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.import-modal {
  ::v-deep {
    .el-upload-dragger, .el-upload {
      width: 100%;
    }
  }
  
  &-operation {
    margin-top: 20px;
    text-align: center;
  }
  &__content {
    &--importing {
      text-align: center;
      p {
        margin-bottom: 5px;
      }
      
      .el-icon-loading {
        font-size: 56px;
      }
    }
    &--imported {
      text-align: center;
      
      .el-icon-success {
        font-size: 60px;
        color: #67C23A;
        margin-bottom: 8px;
      }
    }
  }
  &__desc{
    font-size: 14px;
    color: $--table-font-color;
    margin-bottom: 8px;
    span {
      color: $--color-primary;
    }
  }
}
.file-box {
  height: 100%;
  padding: 0 10px;
  .el-icon-document-checked {
    font-size: 66px;
    color: $--color-primary;
  }
}
</style>
